import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconService } from './../../../services/icon.service';
import { ViewBookingViewModeEnum } from './../../../models/enums/ViewBooking/ViewBookingEnum';
import { SearchService } from './../../../services/search.service';
import { Component,EventEmitter,Output, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { ThemePalette } from '@angular/material/core';
import { DateFormatPipe } from './../../../common/pipes/DateFormatPipe';
import { ViewBookingBaseComponent } from '../view-booking-base/view-booking-base.component';



@Component({
  selector: 'update-additional-modal',
  templateUrl: './update-additional-modal.component.html',
  styleUrls: ['./update-additional-modal.component.scss']
})
export class UpdateAdditionalModalComponent extends ViewBookingBaseComponent implements OnInit {

  @Output() onCancel = new EventEmitter();
  viewMode: ViewBookingViewModeEnum = ViewBookingViewModeEnum.Default;

  searchForm: FormGroup;
  submitted = false;


  faTimesCircle=faTimesCircle;
  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  faClock = faClock;
  vehicle;
  currency;
  duration;


  constructor(
    private iconService:IconService,
    private domSanitizer:DomSanitizer,
    private matIconRegistry:MatIconRegistry,
    private formBuilder: FormBuilder,
    private searchService: SearchService,
    private bookingService: BookingService,
    //private dialogRef: MatDialogRef<UpdateAdditionalModalComponent>,
    //@Inject(MAT_DIALOG_DATA) data,
    public translateService: TranslateService) {
    super(iconService,domSanitizer,matIconRegistry);
    //this.vehicle = searchService.getVehicle();
    this.currency = searchService.getCurrency();

  }

  ngOnInit() {

    this.bookingService.vehicle.subscribe(res => {
      this.vehicle = res;
    });

  }


  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }


  }

  ngOnDestroy(): void {

  }

  close(): void {
   // this.dialogRef.close();
  }
  closeOnUpdate() {
    // this.dialogRef.close(true);
  }

  saveSuccessful() {
    this.closeOnUpdate();
    this.bookingService.updateViewBookingState();
  }

  cancelClicked(){
    this.onCancel.emit(true);
    this.ngOnDestroy();
  }

  resetViewMode(){
    this.viewMode=ViewBookingViewModeEnum.Default;
  }
}
